export const styles = {
  gridItem: {
    width: "100%",
    "& .MuiOutlinedInput-root.Mui-focused fieldset": {
      borderColor: "secondary.main",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "secondary.main",
    },

    "& .MuiOutlinedInput-root": {
      px: "9px",
    },
  },
  autocomplete: {
    "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
      minWidth: "0.25rem",
    },
    "& .MuiAutocomplete-tag": {
      maxWidth: "calc(100% - 5.5rem)",
    },
    "& .MuiOutlinedInput-root": {
      pr: "1.1rem !important",
    },
  },
  timePickerPopper: {
    "& .MuiDigitalClock-root": {
      width: "15rem",
    },
    "& .MuiDigitalClock-list": {
      width: "100%",
    },
    "& .MuiDigitalClock-item.Mui-selected": {
      backgroundColor: "secondary.main",
      color: "common.white",
    },
    "& .MuiDigitalClock-item.Mui-selected.Mui-focused": {
      backgroundColor: "secondary.main",
      color: "common.white",
    },
    "& .MuiDigitalClock-item.Mui-selected:hover": {
      backgroundColor: "secondary.dark",
      color: "common.white",
    },
    "& .MuiDigitalClock-item.Mui-focused": {
      backgroundColor: "secondary.main",
      color: "common.white",
    },
    "& .MuiDigitalClock-item:hover": {
      backgroundColor: "action.hover",
    },
    "& .MuiDigitalClock-item.Mui-focusVisible:not(.Mui-selected)": {
      backgroundColor: "action.hover",
    },
  },
  datePickerPopper: {
    "& .MuiPickersDay-root.Mui-selected": {
      backgroundColor: "secondary.main",
      color: "common.white",
    },
    "& .MuiPickersDay-root.Mui-selected:hover": {
      backgroundColor: "secondary.dark",
      color: "common.white",
    },
    "& .MuiPickersDay-root:hover": {
      backgroundColor: "secondary.light",
    },
    "& .MuiPickersDay-root:focus.Mui-selected": {
      backgroundColor: "secondary.main",
      color: "common.white",
    },
    "& .MuiPickersDay-root:focus.Mui-selected:hover": {
      backgroundColor: "secondary.dark",
      color: "common.white",
    },
    "& .MuiPickersDay-root:focus": {
      backgroundColor: "secondary.light",
    },
    "& .MuiPickersYear-yearButton.Mui-selected": {
      backgroundColor: "secondary.main",
      color: "common.white",
    },
    "& .MuiPickersYear-yearButton.Mui-selected:hover": {
      backgroundColor: "secondary.dark",
      color: "common.white",
    },
    "& .MuiPickersYear-yearButton:hover": {
      backgroundColor: "secondary.light",
    },
    "& .MuiPickersYear-yearButton:focus": {
      backgroundColor: "secondary.light",
    },
    "& .MuiPickersYear-yearButton:focus.Mui-selected": {
      backgroundColor: "secondary.main",
      color: "common.white",
    },
  },
  icon: {
    color: "secondary.main",
    p: "0.25rem",
  },
  clearIcon: {
    p: "0.1rem",
  },
  autoCompleteList: {
    textAlign: "left",
    "& .MuiAutocomplete-option[aria-selected='true']": {
      backgroundColor: "secondary.main",
      color: "common.white",
    },
    "& .MuiAutocomplete-option[aria-selected='true']:hover": {
      backgroundColor: "secondary.dark",
      color: "common.white",
    },
    "& .MuiAutocomplete-option[aria-selected='true'].Mui-focused": {
      backgroundColor: "secondary.main",
      color: "common.white",
    },
    "& .MuiAutocomplete-option.Mui-focused:not([aria-selected='true'])": {
      backgroundColor: "action.hover",
    },
  },
};
